import styled from '@emotion/styled';

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  min-height: 768px;
  min-width: 1280px;
`;
